<template>
    <div class="widget-layout">
      <slot></slot>
    </div>
  </template>
  
  <script>
  export default {
    name: 'WidgetLayout',
  };
  </script>
  
  <style scoped>
  /* Минимальные стили */
  .widget-layout body, .widget-layout html {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  </style>
  


// WEBPACK FOOTER //
// src/layouts/WidgetLayout.vue